<template>
  <div class="absolute-notification" v-if="notification !== null">
    <div class="alert alert-success">{{ notification }}</div>
  </div>
</template>

<script>
export default {
  name: "AbsoluteNotification",
  props: ['notification']
}
</script>

<style lang="scss" scoped>
.absolute-notification {
  position: fixed;
  right: 20px;
  top: 20px;
  z-index: 9999;
  max-width: 100%;
  overflow: hidden;
}
</style>
